import React, { FC, useState } from "react";
import { Input, Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const CurrencyInput: FC<{
  value?: number;
  suffix?: string;
  onChange: any;
}> = ({
  value,
  suffix,
  onChange
}) => {
  const [val, setVal] = useState<any>(value|0);
  return (
    <div className="d-flex custom-number">
      <Button className="beam-btn d-flex" onClick={() => {
        setVal(parseFloat(val)-1)
        onChange(parseFloat(val)-1)
        }}>
        <MinusOutlined />
      </Button>
      <Input  
        className="beam-input w-auto mx-2"
        placeholder='Enter Number'  
        min={0} 
        type="number"
        value={val}
        suffix={suffix} 
        onChange={(e) => {
          setVal(e.target.value)
          onChange(e.target.value)
          }} />
      <Button className="beam-btn d-flex" onClick={() => {
        setVal(parseFloat(val)+1)
        onChange(parseFloat(val)+1)
        }}>
       <PlusOutlined />
      </Button>
    </div>
  );
};

export default CurrencyInput;
